import { Component, HostListener } from '@angular/core';
import { UsuarioAPI } from '../../../core/models/AuthModel';
import { Router, NavigationEnd } from '@angular/router';
import { inject } from '@angular/core';
import { filter } from 'rxjs/operators';
import { SidebarService } from '../../../core/services/sidebar/sidebar-service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { KeyStorageUtil } from '../../utils/keystorage';

@Component({
  selector: 'app-navbar',
  imports: [],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css',
})
export class Navbar {
  //user data
  user: UsuarioAPI = {} as UsuarioAPI;

  ngOnInit() {
    this.user = KeyStorageUtil.getItem('usuario')!;
  }

  constructor(private router: Router, private authService: AuthService) {}

  //dropdown
  isDropdownOpen: boolean = false;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  logout() {
    this.authService.logout();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = target.closest('.relative');

    if (!dropdown) this.isDropdownOpen = false;
  }

  //sidebar toggle

  protected sidebarService = inject(SidebarService);
  toggleSidebar() {
    this.sidebarService.toggle();
  }
}
